import { Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { Trans } from "react-i18next";

type Props = {
  i18nKey: string;
  trailing?: ReactNode;
};

export const ExplanationHint = ({ i18nKey, trailing }: Props) => (
  <Stack gap={4}>
    <Typography
      fontSize="1rem"
      color="text.secondary"
      fontWeight={400}
      sx={{ strong: { color: "text.primary", fontWeight: 400 } }}
    >
      <Trans
        i18nKey={i18nKey}
        components={{
          newline: <br />,
          bold: <strong />,
        }}
      />
    </Typography>
    {trailing}
  </Stack>
);
